const _canvas = document.createElement("canvas");
const _gl2 = _canvas.getContext("webgl2");
if (_gl2) {
  _canvas.height = 1;
  _canvas.width = 1;
}

function getWebGL2Context(gl?: WebGL2RenderingContext): WebGL2RenderingContext | undefined {
  return gl ?? _gl2 ?? undefined;
}

export const supportsFloatTextures = (gl?: WebGL2RenderingContext) => {
  const context = getWebGL2Context(gl);
  if (!context) {
    return false;
  }
  const hasColorBufferFloat = !!context.getExtension("EXT_color_buffer_float");
  const hasFloatLinear = !!context.getExtension("OES_texture_float_linear");
  return hasColorBufferFloat && hasFloatLinear;
};

export const supportsDerivatives = (gl?: WebGL2RenderingContext) => {
  return !!getWebGL2Context(gl);
};

export const supportsGpuTiming = (gl?: WebGL2RenderingContext) => {
  const context = getWebGL2Context(gl);
  if (!context) {
    return false;
  }
  return !!context.getExtension("EXT_disjoint_timer_query_webgl2");
};
